export default __webpack_public_path__ + "2cf597de3fa87d353c10872acc7cc094.png";